module.exports = __webpack_public_path__ + "img/huyen_trang.16a8cd20.jpg";